import moment from 'moment';
// Função para verificar alterações genéricas
const getChanges = (original, updated) => {
    const changedFields = {};
    Object.keys(original).forEach(key => {
        if (original[key] !== updated[key]) {
            changedFields[key] = { original: original[key], updated: updated[key] };
        }
    });
    return changedFields;
};
// Função para limpar um objeto, mantendo apenas as chaves especificadas
const filterObject = (obj, keys) => {
    return keys.reduce((acc, key) => {
        if (key in obj) {
            acc[key] = obj[key];
        }
        return acc;
    }, {});
};
// Função genérica para registar histórico de alterações
const historicoAlteracoes = async (original, updated, fields, userId, estado) => {
    const observacoesList = [];
    let count = 0;
    // Mapeia os campos relevantes
    const fieldMap = Object.fromEntries(fields.map(({ field, name }) => [field, name]));
    const getDesignacao = (id, options) => {
        return options?.find(option => option.id === id)?.designacao ?? id;
    };
    if (updated.active === 0) {
        observacoesList.push(`Removido "${fieldMap['active']}"\nData: ${moment().format()}\n\n\n`);
        count++;
    }
    else if (!original) {
        for (const { field, name, options, dontCheckChanges } of fields) {
            if (updated[field] != null) {
                const valorFormatado = options ? getDesignacao(updated[field], options) : updated[field];
                observacoesList.push(dontCheckChanges ? `Adicionado ${name}\n\n\n` : `Adicionado ${name}: \n"${valorFormatado}"\n\n\n`);
                count++;
            }
        }
    }
    else {
        // Filtra os objetos para comparação
        const originalFiltered = filterObject(original, Object.keys(fieldMap));
        const updatedFiltered = filterObject(updated, Object.keys(fieldMap));
        // Verifica alterações
        const alteracoes = getChanges(originalFiltered, updatedFiltered);
        if (Object.keys(alteracoes).length > 0) {
            for (const campo in alteracoes) {
                const alteracao = alteracoes[campo];
                const campoNome = fieldMap[campo] || campo;
                const fieldConfig = fields.find(f => f.field === campo);
                count++;
                if (fieldConfig?.dontCheckChanges) {
                    observacoesList.push(`Alterações no campo ${campoNome}\n\n\n`);
                }
                else {
                    let valorOriginal = fieldConfig?.options
                        ? getDesignacao(alteracao.original, fieldConfig.options)
                        : alteracao.original !== null && alteracao.original !== undefined
                            ? alteracao.original.toString()
                            : 'N/D';
                    let valorAtualizado = fieldConfig?.options
                        ? getDesignacao(alteracao.updated, fieldConfig.options)
                        : alteracao.updated !== null && alteracao.updated !== undefined
                            ? alteracao.updated.toString()
                            : 'N/D';
                    if (moment(valorOriginal, true).isValid()) {
                        valorOriginal = `${moment(valorOriginal).format('DD-MM-YYYY')} às ${moment(valorOriginal).format('HH:mm')}`;
                    }
                    if (moment(valorAtualizado, true).isValid()) {
                        valorAtualizado = `${moment(valorAtualizado).format('DD-MM-YYYY')} às ${moment(valorAtualizado).format('HH:mm')}`;
                    }
                    if (alteracao.original === null) {
                        observacoesList.push(`Adicionado ${campoNome}: \n${valorAtualizado}\n\n\n`);
                    }
                    else {
                        observacoesList.push(`Alteração de ${campoNome} de \n"${valorOriginal}"\n para \n"${valorAtualizado}"\n\n\n`);
                    }
                }
            }
        }
    }
    if (count > 0) {
        return {
            id: 0,
            dataAlteracao: moment().format(),
            funcionarioId: userId,
            estadoInicial: estado ?? original?.estadoId ?? 10,
            estadoFinal: estado ?? updated.estadoId,
            observacoes: observacoesList.join('\n'),
            active: 1
        };
    }
    return null;
};
export default historicoAlteracoes;
